var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.08296 7H5.08333C5.63562 7 6.08333 7.44772 6.08333 8C6.08333 8.55228 5.63562 9 5.08333 9H1C0.447715 9 0 8.55228 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C7.44772 16 7 15.5523 7 15V10.9167C7 10.3644 7.44772 9.91667 8 9.91667C8.55228 9.91667 9 10.3644 9 10.9167V13.917C11.5125 13.4955 13.4955 11.5125 13.917 9H10.9167C10.3644 9 9.91667 8.55228 9.91667 8C9.91667 7.44772 10.3644 7 10.9167 7H13.917C13.4955 4.48749 11.5125 2.50448 9 2.08296V5.08333C9 5.63562 8.55228 6.08333 8 6.08333C7.44772 6.08333 7 5.63562 7 5.08333V2.08296C4.48749 2.50448 2.50448 4.48749 2.08296 7ZM1.26303 10.1554C1.7598 9.91408 2.35815 10.1212 2.59948 10.6179C3.18756 11.8284 4.17155 12.8124 5.38208 13.4005C5.87885 13.6419 6.08592 14.2402 5.84459 14.737C5.60326 15.2337 5.00491 15.4408 4.50814 15.1995C2.8943 14.4155 1.58453 13.1057 0.800523 11.4919C0.559192 10.9951 0.766264 10.3967 1.26303 10.1554Z",
    fill: "#1D1D38"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocate);
export default __webpack_public_path__ + "static/media/locate.761e503a.svg";
export { ForwardRef as ReactComponent };